import { Version } from "@ascend-ltd/logic-helpers";
import { z } from "zod/v4";
import { OfficeId } from ".";
const OfficesOrderSchema = z.object({
    order: z.array(OfficeId.schema),
    version: Version.schema,
});
export const OfficesOrder = {
    schema: OfficesOrderSchema,
    of: (args) => {
        const values = {
            ...args,
            version: args.version ?? Version.initial(),
        };
        return OfficesOrder.schema.parse(values);
    },
};
//# sourceMappingURL=offices-order.js.map